'use client'

import { EmailSidebarAttachmentsPackagesCard } from '@repo/ui/EmailSidebarAttachmentsPackagesCard'
import { EmailSidebarCard } from '@repo/ui/EmailSidebarCard'
import { EmailSidebarEmailTemplateCard } from '@repo/ui/EmailSidebarEmailTemplateCard'
import { EmailSidebarMatterCard } from '@repo/ui/EmailSidebarMatterCard'
import { EmailSidebarRecipientSelectionCard } from '@repo/ui/EmailSidebarRecipientSelectionCard'
import { MatterHistorySettings } from '@repo/ui/MatterHistorySettings'
import { useEmailCardStore } from '@repo/store/useEmailCardStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import MUIStack from '@mui/material/Stack'

type EmailSidebarProps = {
  testData?: boolean
  sx?: React.CSSProperties
  lockMatterSelection?: boolean
  showMatterHistorySettings?: boolean
}

export const EmailSidebar = ({
  testData = false,
  sx = {},
  lockMatterSelection = false,
  showMatterHistorySettings = true
}: EmailSidebarProps) => {
  const { emailSendingCurrentMatterData, selectedEmailTemplate } = useEmailCardStore()
  const { allowedActions } = useMenuItemsStore()
  const { viewMatterHistory } = allowedActions
  const showMAttachmentsPanel = viewMatterHistory?.allowed || false

  return (
    <MUIStack
      direction="column"
      gap="1.5rem"
      data-testid="EmailSidebar"
      sx={{
        backgroundColor: '#ECEEF2',
        maxWidth: '30%',
        minWidth: '320px',
        width: '100%',
        height: 'auto',
        overflowY: 'auto',
        padding: '1.25rem',
        ...sx
      }}
    >
      <EmailSidebarCard title="Matter" id="matter" disabled={false}>
        <EmailSidebarMatterCard testData={testData} locked={lockMatterSelection} />
      </EmailSidebarCard>
      <EmailSidebarCard
        title="Email Template"
        id="emailTemplate"
        disabled={!emailSendingCurrentMatterData?.clientMatterNo}
      >
        <EmailSidebarEmailTemplateCard testData={testData} />
      </EmailSidebarCard>
      <EmailSidebarCard
        title="Recipients"
        id="recipientSelection"
        disabled={!emailSendingCurrentMatterData?.clientMatterNo}
      >
        <EmailSidebarRecipientSelectionCard
          testData={testData}
          noMatter={!emailSendingCurrentMatterData?.clientMatterNo}
        />
      </EmailSidebarCard>
      {showMAttachmentsPanel && (
        <EmailSidebarCard
          title="Attachments & Packages"
          id="attachmentsPackages"
          disabled={!emailSendingCurrentMatterData?.clientMatterNo}
        >
          <EmailSidebarAttachmentsPackagesCard testData={testData} />
        </EmailSidebarCard>
      )}
      <EmailSidebarCard
        title="Matter History Settings"
        id="matterHistorySettings"
        disabled={!emailSendingCurrentMatterData?.clientMatterNo || !showMatterHistorySettings}
      >
        <MatterHistorySettings />
      </EmailSidebarCard>
    </MUIStack>
  )
}
